import React from 'react';
import ImagemElo from 'assets/img/icones/icon-elo.png';

const LogoElo = props => {
  return (<img src={ImagemElo} width="100" heigth="56" alt="Elo" />)
};
export default LogoElo;